// extracted by mini-css-extract-plugin
export var bottom = "Popover-module--bottom--eVk3m";
export var center = "Popover-module--center--MaWTy";
export var container = "Popover-module--container--lvu88";
export var content = "Popover-module--content--iDPr2";
export var end = "Popover-module--end--+mPb2";
export var left = "Popover-module--left--IK8ig";
export var popover = "Popover-module--popover--Woyhm";
export var popoverFadeIn = "Popover-module--popoverFadeIn--eGHNe";
export var popoverFadeInCenter = "Popover-module--popoverFadeInCenter--sq2Xa";
export var popoverFadeInCenterVertical = "Popover-module--popoverFadeInCenterVertical--YH9e8";
export var right = "Popover-module--right--DF3ur";
export var start = "Popover-module--start--lNcSI";
export var top = "Popover-module--top--Qkqfw";
export var trigger = "Popover-module--trigger--xwN6l";